module.exports = __webpack_public_path__ + "img/rftic.e51b4034.webp";